import { ReactElement, useEffect, useState } from 'react';
import {
  ListPackagesCommand,
  PackageData,
} from '@amzn/awsdev-docs-virtual-smiley-typescript-client';
import { useAuthState } from '../../authentication';
import { callApi } from '../../client';
import { callApiWithPagination } from '../../utils/callApiWithPagination';
import PackagesTable from './ui/PackagesTable';

const PAGE_SIZE = 2000;

const fetchPackages = (token: string): Promise<PackageData[]> =>
  callApiWithPagination(PAGE_SIZE, async ({ pageSize, nextToken }) => {
    const response = await callApi(
      new ListPackagesCommand({
        nextToken,
        pageSize,
      }),
      token
    );

    return {
      items: response.packages,
      nextToken: response.nextToken,
    };
  });

const PackageList = (): ReactElement => {
  const { isAuthenticated, token } = useAuthState();
  const [packages, setPackages] = useState<PackageData[]>([]);
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isActive = true;

    if (!isAuthenticated || !token) {
      setLoading(false);
      return () => {
        isActive = false;
      };
    }

    setLoading(true);
    setHasError(false);

    void fetchPackages(token)
      .then((allPackages) => {
        if (isActive) {
          setPackages(allPackages);
        }
      })
      .catch((error) => {
        console.error('Error retrieving package information:', error);
        if (isActive) {
          setPackages([]);
          setHasError(true);
        }
      })
      .finally(() => {
        if (isActive) {
          setLoading(false);
        }
      });

    return () => {
      // Ignore results from requests that finish after unmount or an auth change.
      isActive = false;
    };
  }, [isAuthenticated, token]);

  return (
    <PackagesTable data={packages} loading={loading} hasError={hasError} />
  );
};

export default PackageList;
